import constants from '@Common/Core/Constant';
import { ComponentType, ShowAllTimeIntervals } from '@Common/Enums/Enum';

import { ComponentChangeGroup } from './ComponentChangeGroup';

export class ComponentDescriptorFactory {
    allCommands = [constants.commands.dataWizard, constants.commands.timeWizard, constants.commands.displayWizard, constants.commands.actionWizard];

    createComponentDescriptor(param) {
        param = $.extend(
            {
                componentGroup: null,
                canHaveDrillDown: false,
                componentToolBarCommands: [],
                defaultComponentWidth: constants.descriptorConstants.defaultComponentWidth,
                defaultComponentHeight: constants.descriptorConstants.defaultComponentHeight,
                defaultDimension: '',
                showTitleByDefault: true,
                hasChartRanges: false,
                seriesSettings: null,
                showAllTimeIntervals: ShowAllTimeIntervals.none,
                isuiComponent: false,
                isPercentComponent: false,
                componentInstanceType: 'Component'
            },
            param
        );
        param.name = ComponentType.getName(param.componentType);
        return param;
    }

    createBaseComponentDescriptor(param) {
        param.componentInstanceType = 'BaseComponent';
        return this.createComponentDescriptor(param);
    }

    createChartDescriptor(param) {
        param = $.extend(
            {
                componentToolBarCommands: this.allCommands,
                componentGroup: constants.componentGroups.chartComponents,
                canHaveDrillDown: true,
                hasChartRanges: true,
                changableGroup: param.changableGroup || this.commonChangableGroup[param.componentType] ? ComponentChangeGroup.changeGroupCommon : null
            },
            param
        );
        return this.createComponentDescriptor(param);
    }

    createProcessComponentDescriptor(param) {
        param = $.extend(
            {
                seriesSettings: this.seriesDescriptorSettings(true, null, false),
                componentToolBarCommands: this.allCommands,
                componentGroup: constants.componentGroups.processComponents,
                hasSeriesSettingsTab: true,
                componentInstanceType: 'ProcessComponent'
            },
            param
        );
        return this.createComponentDescriptor(param);
    }

    seriesDescriptorSettings(hasCellPaintingSettings, sparkSettingsDescriptor, hasBulletSettings) {
        return {
            hasCellPaintingSettings: hasCellPaintingSettings,
            sparkSettingsDescriptor: sparkSettingsDescriptor,
            hasBulletSettings: hasBulletSettings
        };
    }

    createDataDescriptor(specialSeriesCount, dimensionTitles?) {
        const descriptors = [];
        if (dimensionTitles != null && dimensionTitles.length > 0) {
            descriptors.push(this.dimensionDescriptor(constants.dimension1, dimensionTitles[0]));
            if (dimensionTitles.length > 1) {
                descriptors.push(this.dimensionDescriptor(constants.dimension2, dimensionTitles[1]));
            }
        }
        return {
            specialSeriesCount: specialSeriesCount,
            dimensionDescriptors: descriptors.reverse(),
            canChooseCurrentDimensions: true
        };
    }

    dimensionDescriptor(id, title) {
        return {
            id: id,
            title: title
        };
    }

    private commonChangableGroup = [
        ComponentType.areaRange,
        ComponentType.rangeBar,
        ComponentType.pareto,
        ComponentType.splineRange,
        ComponentType.horizontalRangeBar,
        ComponentType.doughnut,
        ComponentType.pie,
        ComponentType.dialGauge,
        ComponentType.linearGauge,
        ComponentType.chartWithRange,
        ComponentType.processControl,
        ComponentType.pyramid,
        ComponentType.funnel,
        ComponentType.pieSemiCircle
    ]
        .map(v => ComponentType.getValue(v))
        .searchTree(ei => ei.id);
}

export let componentDescriptorFactory: ComponentDescriptorFactory = new ComponentDescriptorFactory();
